export default __webpack_public_path__ + "static/media/tiger_wating.d558011d.png";